import { render, staticRenderFns } from "./UsersStatistics.vue?vue&type=template&id=f1bb158c&"
import script from "./UsersStatistics.vue?vue&type=script&lang=js&"
export * from "./UsersStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports